import React from "react";
import { connect } from "react-redux";
import { getNumeroPatronal, eliminarNumeroPatronal } from "../numeroPatronal/NumeroPatronalService";
import "../../styles/Empresa.css";
import NumeroPatronalDialogContent from "../numeroPatronal/NumeroPatronal";
import Navbar from "../home/Navbar";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { Modal, Col, Row, Container, Button } from 'react-bootstrap';
import delete_forever from '../../styles/icons/delete.svg';
import edit from '../../styles/icons/edit.svg';
import ExclamacionIcon from '../../styles/icons/exclamation-circle.svg'
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";

class NumerosPatronales extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Registrar nuevo Numero Patronal",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedNumeroPatronal: {
        numero: "",
        descripcion: "",
        id: "",
      },
      mostrarMensaje: false,
      mensaje: "",
      severity: "",
      dialogIsOpen: false,
      openPantallaCarga: false,
      pageSize: 10,
      search: "",
      loading: true
    };
    this.tableRef = React.createRef();
  }

  handleDialog = (value) => {
    this.setState({
      dialogIsOpen: value,
      mostrarMensaje: false
    });
  };
  handleDialogClose = (value, mensaje = "", severity) => {
    if (!value) {
      this.componentDidMount()
      if (mensaje !== "") {
        this.setState({
          mostrarMensaje: true,
          mensaje: mensaje,
          severity: severity
        });
      }
    }
    this.setState({
      dialogIsOpen: value
    });
  };



  handleNewNumeroPatronal = () => {
    this.setState(
      {
        dialogTitle: "Registrar Número Patronal",
        selectedNumeroPatronal: {
          nombre: "",
          formato: "",
          acciones: "",
          activo: true,
          id: "",
        },
        dialogType: "add",
        submitText: "Guardar",
        disabledInput: false,
        open: false
      },
      () => {
        this.handleDialog(true);
      }
    );
  };
  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensaje: false,
    });
  };

  eliminar = () => {
    this.handleClose();
    this.setState({ openPantallaCarga: true });
    this.props.eliminarNumeroPatronal(this.state.selectedNumeroPatronal.id).then((response) => {
      this.setState({ openPantallaCarga: false });
      if (!response.error) {
        this.setState({
          mensaje: response.mensaje,
          severity: "success"
        })
      } else {
        this.setState({
          mensaje: response.mensaje,
          severity: "danger"
        })
      }
      this.fetchNroPatronal(0, this.state.pageSize, "");
      this.setState({ mostrarMensaje: true })
    }
    )
  }
    handlePageChange(newPage) {
      if (newPage >= 0 && newPage < this.state.totalPages) {
        this.setState({ page: newPage }, () => {
          this.fetchNroPatronal(newPage, this.state.pageSize, "");
        });
      }
    }
    componentDidMount() {
      this.fetchNroPatronal(0, this.state.pageSize, "");
    }
  
    handlePageChange = (newPage) => {
      if (newPage >= 0 && newPage < this.state.totalPages) {
        this.setState({ page: newPage }, () => {
          this.fetchNroPatronal(this.state.page, this.state.pageSize, "");
        });
      }
    };
  
    handlePageSizeChange = (event) => {
      const newPageSize = parseInt(event.target.value, 10);
      this.setState({ pageSize: newPageSize, page: 0 }, () => {
        this.fetchNroPatronal(this.state.page, this.state.pageSize, "");
      });
    };
  
    renderPageNumbers() {
      const { page, totalPages } = this.state;
      const maxVisiblePages = 5; // Máximo de páginas visibles
  
      let pages = [];
  
      if (totalPages <= maxVisiblePages) {
        // Mostrar todas las páginas si son pocas
        for (let i = 0; i < totalPages; i++) {
          pages.push(
            <li
              key={i}
              className={`page-item ${page === i ? "active" : ""}`}
              onClick={() => this.handlePageChange(i)}
            >
              <a className="page-link" type="Button">{i + 1}</a>
            </li>
          );
        }
      } else {
        // Mostrar primeras páginas, últimas y cercanas a la actual
        const startPage = Math.max(0, page - 2);
        const endPage = Math.min(totalPages - 1, page + 2);
  
        // Agregar primera página
        if (startPage > 0) {
          pages.push(
            <li
              key={0}
              className={`page-item ${page === 0 ? "active" : ""}`}
              onClick={() => this.handlePageChange(0)}
            >
              <a className="page-link" type="Button">1</a>
            </li>
          );
          if (startPage > 1) {
            pages.push(
              <li key="start-ellipsis" className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            );
          }
        }
  
        // Agregar páginas visibles
        for (let i = startPage; i <= endPage; i++) {
          pages.push(
            <li
              key={i}
              className={`page-item ${page === i ? "active" : ""}`}
              onClick={() => this.handlePageChange(i)}
            >
              <a className="page-link" type="Button">{i + 1}</a>
            </li>
          );
        }
  
        // Agregar última página
        if (endPage < totalPages - 1) {
          if (endPage < totalPages - 2) {
            pages.push(
              <li key="end-ellipsis" className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            );
          }
          pages.push(
            <li
              key={totalPages - 1}
              className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
              onClick={() => this.handlePageChange(totalPages - 1)}
            >
              <a className="page-link" type="Button">{totalPages}</a>
            </li>
          );
        }
      }
  
      return pages;
    }
  
    fetchNroPatronal(page, pageSize, search) {
      this.setState({ loading: true });
      this.props.getNumeroPatronal(page, pageSize, search).then(() => {
        this.setState({
          numeroPatronal: this.props.numeroPatronalData.numeroPatronal,
          page: this.props.numeroPatronalData.page,
          totalCount: this.props.numeroPatronalData.totalCount,
          totalPages: Math.ceil(
            this.props.numeroPatronalData.totalCount / pageSize
          ),
          loading: false,
        });
      });
    }
  
    handleSearchChange = (e) => {
      const searchValue = e.target.value;
      this.setState({ search: searchValue }, () => {
        this.fetchNroPatronal(0, this.state.pageSize, this.state.search);
      });
    };

  render() {
    return (
      <div>
        <div className="dashboardContent">
          <div className="container-fluid">
            <PantallaCarga open={this.state.openPantallaCarga} />
            <Modal
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.open}
              onHide={this.handleClose}
              backdrop="static"
              keyboard="false"
            >
              <Container>
                <Modal.Body>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                    <img src={ExclamacionIcon} style={{margin: '40px'}}></img>
                    </Col>
                  </Row>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                      <p><strong>Estas Seguro que desea eliminar el Número MTESS Patronal?</strong></p>
                    </Col>
                  </Row>
                  <Row style={{ background: "#EDF2F9" }}>
                    <Col>
                      <p><strong>Número Patronal:</strong> {this.state.selectedNumeroPatronal.numero}</p>
                      <p><strong>Descripción: </strong>{this.state.selectedNumeroPatronal.descripcion}</p>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={this.handleClose} variant="contained">Cancelar</Button>
                  <Button onClick={this.eliminar} color="primary" autoFocus>
                    Aceptar
                  </Button>
                </Modal.Footer>
              </Container>
            </Modal>
            <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.dialogIsOpen}
              onHide={this.handleDialogClose}
              backdrop="static"
              keyboard="false">
              <NumeroPatronalDialogContent
                numeroPatronal={this.state.selectedNumeroPatronal}
                handleClose={this.handleDialogClose}
                type={this.state.dialogType}
                submitText={this.state.submitText}
                disabledInput={this.state.disabledInput}
                dialogTitle={this.state.dialogTitle}
              />

            </Modal>
            <MensajeFlash
              mensaje={this.state.mensaje}
              open={this.state.mostrarMensaje}
              severity={this.state.severity}
              handleClose={this.handleCloseMensajeFlash} />
            <div className="sectionHeader">
              <h1 className="pageTitle"> Número MTESS Patronal </h1>
              <div className="actions">
                <a className="btn btn-primary" onClick={this.handleNewNumeroPatronal}> Registrar Número Patronal  </a>
              </div>
            </div>
            <Navbar
              menuActual={window.location.hash}
              seccionActual={'configuracion'}
            />
          <div className="contentBuscador card">
              <form className="searchForm">
                <div className="input-group input-group-lg">
                  <span className="input-group-text border-0" id="basic-addon2">
                    <img src={search} />
                  </span>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Buscar.."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                    value={this.state.search}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </form>
            </div>
            <div className="contentPage card" style={{ padding: "0px" }}>
            {this.state.loading ? (
                // Muestra el spinner mientras loading sea true
                <div className="d-flex justify-content-center p-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                </div>
              ) : ( <div>
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Descripción</th>
                      <th scope="col">Numero Patronal</th>
                      <th scope="col">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.numeroPatronalData.numeroPatronal.map((numeroPatronal, index) => (
                      <tr key={index}>
                        <th scope="row">{numeroPatronal.descripcion}</th>
                        <td>{numeroPatronal.numero}</td>
                        <td>
                          <div className="table-actions">
                          <a class="btn btn-secondary btn-md btn-floating" onClick={() => {
                      this.setState({
                        dialogTitle: "Editar Número Patronal",
                        selectedNumeroPatronal: numeroPatronal,
                        dialogType: "edit",
                        submitText: "Editar",
                        disabledInput: false
                      }, () => {
                        this.handleDialog(true);
                      });
                    }}>
                          <img src={edit} />
                          </a>
                          <a class="btn btn-secondary btn-md btn-floating" onClick={() => {
                      this.setState({
                        dialogTitle: "Eliminar Numero Patronal",
                        selectedNumeroPatronal: numeroPatronal,
                        dialogType: "eliminar",
                        submitText: "eliminar",
                        disabledInput: false
                      }, () => {
                        this.handleClickOpen();
                      });
                    }}>
                          <img src={delete_forever} />
                          </a>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div id="paginador">
                    <label>
                      Mostrar
                      <select
                        className="form-control custom-select"
                        id="maxRows"
                        name="state"
                        value={this.state.pageSize}
                        onChange={this.handlePageSizeChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                      </select>
                      resultados.
                    </label>
                    <ul className="pagination mb-0">
                      <li
                        className={`page-item ${
                          this.state.page === 0 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page - 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_left</span>
                        </a>
                      </li>
                      {this.renderPageNumbers()}
                      <li
                        className={`page-item ${
                          this.state.page === this.state.totalPages - 1
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() =>
                          this.handlePageChange(this.state.page + 1)
                        }
                      >
                        <a className="page-link" type="Button">
                          <span className="material-icons">chevron_right</span>
                        </a>
                      </li>
                    </ul>
                  </div>
              </div>)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getNumeroPatronal: (page, size, search) => dispatch(getNumeroPatronal(page, size, search)),
  eliminarNumeroPatronal: (id) => dispatch(eliminarNumeroPatronal(id))
});

const mapStateToProps = (state) => ({
  numeroPatronalData: state.numeroPatronalData,
});

export default connect(mapStateToProps, mapDispatchToProps)(NumerosPatronales);
